import * as React from 'react'
import { Container, Box, Typography, Paper } from '@mui/material'

import imgPrix from '../../assets/images/meilleur-prix.jpg'
import imgProcess from '../../assets/images/emballage.jpg'
import imgNature from '../../assets/images/nature.jpg'

// i18n
import { useI18n } from '../../i18n/I18nProvider'
import differenceI18n from '../../i18n/components/services/difference.i18n'

export default function Difference() {
  const { t, register } = useI18n()
  // on enregistre dans le namespace "services" (fusion avec les autres sous-parties)
  React.useEffect(() => { register('services', differenceI18n) }, [register])

  // cartes (titres/descriptions/alts) depuis l’i18n
  const items = React.useMemo(() => ([
    {
      img: imgPrix,
      title: t('services.difference.cards.prix.title'),
      desc: t('services.difference.cards.prix.desc'),
      alt:  t('services.difference.cards.prix.alt'),
    },
    {
      img: imgProcess,
      title: t('services.difference.cards.process.title'),
      desc: t('services.difference.cards.process.desc'),
      alt:  t('services.difference.cards.process.alt'),
    },
    {
      img: imgNature,
      title: t('services.difference.cards.nature.title'),
      desc: t('services.difference.cards.nature.desc'),
      alt:  t('services.difference.cards.nature.alt'),
      objectPosition: 'center 40%',
    },
  ]), [t])

  return (
    <Box sx={{ bgcolor: '#fff', borderTop: '1px solid #eee' }}>
      <Container maxWidth="lg" sx={{ pt: { xs: 3, md: 4 }, pb: { xs: 5, md: 7 } }}>
        {/* Titre section */}
        <Typography
          component="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: 22, sm: 24, md: 28 },   // titre de section harmonisé
            lineHeight: 1.2,
            mb: 2,
          }}
        >
          {t('services.difference.title')}
        </Typography>

        {/* Paragraphe d’intro (mots en gras conservés) */}
        <Typography
          sx={{ color: 'text.secondary', fontSize: { xs: 14.5, sm: 15, md: 16 }, lineHeight: 1.7, mb: 0.5 }}
        >
          {t('services.difference.p1.s1')}
          <b>{t('services.difference.p1.bold1')}</b>
          {t('services.difference.p1.s2')}
          <b>{t('services.difference.p1.bold2')}</b>
          {t('services.difference.p1.s3')}
          <b>{t('services.difference.p1.bold3')}</b>
          {t('services.difference.p1.s4')}
        </Typography>

        <Typography
          sx={{ color: 'text.secondary', fontSize: { xs: 14.5, sm: 15, md: 16 }, lineHeight: 1.7, mb: 0.5 }}
        >
          {t('services.difference.p2.s1')}
          <b>{t('services.difference.p2.bold1')}</b>
          {t('services.difference.p2.s2')}
          <b>{t('services.difference.p2.bold2')}</b>
          {t('services.difference.p2.s3')}
          <b>{t('services.difference.p2.bold3')}</b>
          {t('services.difference.p2.s4')}
        </Typography>

        <Typography
          sx={{ color: 'text.secondary', fontSize: { xs: 14.5, sm: 15, md: 16 }, lineHeight: 1.7, mb: 4 }}
        >
          <b>{t('services.difference.p3.bold1')}</b>
          {t('services.difference.p3.s2')}
          <b>{t('services.difference.p3.bold2')}</b>
          {t('services.difference.p3.s3')}
          <b>{t('services.difference.p3.bold3')}</b>
          {t('services.difference.p3.s4')}
          <b>{t('services.difference.p3.bold4')}</b>
          {t('services.difference.p3.s5')}
          <b>{t('services.difference.p3.bold5')}</b>
          {t('services.difference.p3.s6')}
          <b>{t('services.difference.p3.bold6')}</b>
          {t('services.difference.p3.s7')}
        </Typography>

        {/* Cartes en CSS Grid */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            gap: { xs: 2, md: 3 },
            width: '100%',
          }}
        >
          {items.map((it) => (
            <Paper
              key={it.title}
              elevation={3}
              sx={{
                position: 'relative',
                borderRadius: 3,
                overflow: 'hidden',
                width: '100%',
                height: { xs: 210, sm: 220, md: 230 },
                '&:hover .card-img': { transform: 'scale(1.04)' },
              }}
            >
              {/* Image */}
              <Box
                component="img"
                className="card-img"
                src={it.img}
                alt={it.alt}
                loading="lazy"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: it.objectPosition || 'center',
                  display: 'block',
                  transition: 'transform .25s ease',
                }}
              />

              {/* Overlay texte */}
              <Box
                sx={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  bottom: 0,
                  bgcolor: 'rgba(0,0,0,0.75)',
                  p: 2,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: 16, sm: 16.5, md: 17 }, // titre carte harmonisé
                    color: '#fff',
                    lineHeight: 1.3,
                  }}
                >
                  {it.title}
                </Typography>
                <Typography
                  sx={{
                    color: '#fff',
                    fontSize: { xs: 13.5, sm: 14, md: 14.5 }, // description carte harmonisée
                    lineHeight: 1.45,
                    mt: 0.5,
                  }}
                >
                  {it.desc}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  )
}